<template>
  <!-- <v-dialog v-model="showContactDialog" max-width="600" persistent> -->
  <v-card max-width="600" persistent>
    <div
      v-if="!selectedBranches"
      class="flex justify-between items-center border-b border-gray-200 p-4"
    >
      <h3 class="form-title">Add Contact</h3>
      <v-icon class="cursor-pointer" @click="cancelForm">mdi-close</v-icon>
    </div>
    <v-card-text>
      <!-- Contact form fields -->
      <div class="flex items-center ml-5 mt-4" v-if="selectedBranches">
        <label class="block font-medium w-32 text-[#464A53] dark-text-color">
          Customer Address:
        </label>
        <div class="flex flex-1 border border-gray-300 rounded-lg overflow-hidden">
          <select
            v-model="branchId"
            class="form-input flex-1 p-2 bg-transparent focus:outline-none w-48"
          >
            <option v-for="(branch, index) in selectedBranches" :key="index" :value="branch._id">
              {{ getFullAddress(branch?.address) }}
            </option>
          </select>
        </div>
      </div>

      <div class="p-4">
        <!-- <label class="block font-medium w-32 text-[#464A53] dark-text-color">
          {{ contactLabels.firstName }}:
          <span class="text-red-500">*</span>
        </label> -->
        <v-text-field
          v-model="newContact.firstName"
          :label="contactLabels.firstName"
          :error="checkForm && !newContact.firstName.trim()"
          :error-messages="
            checkForm && !newContact.firstName.trim()
              ? `${contactLabels.firstName} is Required.`
              : ''
          "
          class="pb-4"
          hide-details="auto"
          outlined
          dense
        ></v-text-field>

        <!-- <label for="lastName" class="block font-medium w-32 text-[#464A53] dark-text-color">
          {{ contactLabels.lastName }}:
        </label> -->
        <v-text-field
          v-model="newContact.lastName"
          class="pb-4"
          :label="contactLabels.lastName"
          hide-details
          outlined
          dense
        ></v-text-field>

        <!-- <label class="block font-medium w-32 text-[#464A53] dark-text-color">
          {{ contactLabels.contactDesignation }}:
        </label> -->
        <v-text-field
          v-model="newContact.designation"
          class="pb-4"
          :label="contactLabels.contactDesignation"
          hide-details
          outlined
          dense
        ></v-text-field>

        <!-- <label class="block font-medium w-32 text-[#464A53] dark-text-color">
          {{ contactLabels.contactNumber }}:
          <span class="text-red-500">*</span>
        </label> -->
        <v-text-field
          v-model="newContact.phoneNumber"
          :error="checkForm && !newContact.phoneNumber.trim()"
          :error-messages="
            checkForm && !newContact.phoneNumber.trim()
              ? `${contactLabels.contactNumber} is Required.`
              : ''
          "
          class="pb-4"
          :label="contactLabels.contactNumber"
          hide-details="auto"
          outlined
          dense
        ></v-text-field>

        <!-- <label class="block font-medium w-32 text-[#464A53] dark-text-color">
          {{ contactLabels.contactEmail }}:
        </label> -->
        <v-text-field
          v-model="newContact.email"
          :label="contactLabels.contactEmail"
          hide-details
          outlined
          dense
        ></v-text-field>
      </div>
    </v-card-text>

    <div class="p-4 border-t flex justify-end">
      <v-btn text @click="cancelForm" style="text-transform: none">Cancel</v-btn>
      <v-btn
        class="white--text"
        :color="$vuetify.theme.currentTheme.primary"
        @click="addContact"
        style="text-transform: none"
      >
        <v-icon left>mdi-content-save</v-icon>
        Save</v-btn
      >
    </div>
  </v-card>
  <!-- </v-dialog> -->
</template>
<script>
import { contactLabels } from '@/utils/workforce/formLabels'
export default {
  name: 'AddContact',
  props: {
    selectedBranchId: String,
    showContactDialog: Boolean,
    editContact: Object,
    selectedBranches: { type: Array, default: null }
  },
  data() {
    return {
      contactLabels: contactLabels,
      checkForm: false,
      branchId: this.selectedBranches ? this.selectedBranches[0]?._id : null,
      newContact: {
        firstName: '',
        lastName: '',
        designation: '',
        phoneNumber: '',
        email: ''
      }
    }
  },
  mounted() {
    this.populateContact()
  },
  methods: {
    addContact() {
      this.checkForm = true
      if (this.validateContactData()) {
        const contactData = {
          contact: {
            firstName: this.newContact.firstName,
            lastName: this.newContact.lastName,
            designation: this.newContact.designation,
            phoneNumber: this.newContact.phoneNumber,
            email: this.newContact.email || undefined
          }
        }

        const branchId = this.selectedBranchId || this.branchId
        this.$axios
          .post(`/addContact/${branchId}`, contactData)
          .then((response) => {
            const updatedCompany = response.data.company
            this.$emit('contact-added', updatedCompany)

            const addedBranch = updatedCompany.companyBranches.find(
              (branch) => branch._id === branchId
            )
            const lastContact = addedBranch.contacts[addedBranch.contacts.length - 1]
            this.$emit('contactAdded', lastContact)
            this.newContact = {
              firstName: '',
              lastName: '',
              designation: '',
              phoneNumber: '',
              email: ''
            }
            this.cancelForm()
            this.showContactDialog = false
            this.$toast.success('New contact added into the company branch !!!')
          })
          .catch((error) => {
            console.error('Error adding new contact:', error)
            this.$toast.error('Error in contact addition !!!')
          })
      }
    },
    validateContactData() {
      this.checkForm = true
      if (this.newContact.firstName.trim() === '' || this.newContact.phoneNumber.trim() === '') {
        return false
      }

      return true
    },
    cancelForm() {
      this.$emit('close')
      this.checkForm = false
    },
    populateContact() {
      if (this.editContact) {
        this.newContact.firstName = this.editContact?.firstName
        this.newContact.lastName = this.editContact?.lastName
        this.newContact.email = this.editContact?.email
        this.newContact.designation = this.editContact?.designation
        this.newContact.phoneNumber = this.editContact?.phoneNumber
      }
    },
    getFullAddress(address) {
      if (address) {
        const { addressLine1, addressLine2, city, country, pinCode, state } = address

        return [addressLine1, addressLine2, city, country, pinCode, state].join(', ') || ''
      }
      return '—'
    }
  }
}
</script>
<style scoped>
.form-title {
  font-size: 1.25rem;
  padding: 0px;
  font-weight: 600;
  color: #21427d;
  margin: 0;
}
</style>
